import { useEffect, useState } from "react";
import { useGame } from "../header/GameContext";
import FooterButton from "../footer/footerText2Button";
import "./intro.css";
import { saveToSheet } from "../../api/sheet";
import { confirmEntryCode } from "../../api/entryCode";

/* 🔑 keyCode 생성 */
const generateKeyCode = () =>
  (
    Date.now().toString(36) + Math.random().toString(36).substring(2, 8)
  ).toUpperCase();

function Intro({
  handleName,
  setHandleName,
  handleName2,
  setHandleName2,
  onFinish,
  defaultPath,
}) {
  const { setPlayerKeyCode, setIntroTeam, setIntroInCode, pauseTimer } =
    useGame();

  const [isLoading, setIsLoading] = useState(false);

  const safeName = handleName || "";
  const isActive = safeName.trim().length > 0;

  const safeName2 = handleName2 || "";
  const isActive2 = safeName2.trim().length > 0;

  const handleStart = async () => {
    if (!handleName.trim()) {
      alert("팀명을 입력하세요.");
      return;
    }
    if (!handleName2.trim()) {
      alert("입장 코드를 입력하세요.");
      return;
    }

    const keyCode = generateKeyCode();

    setIsLoading(true); // 로딩 시작

    try {
      //***** Entry Code 검증 *****//
      await confirmEntryCode(handleName2);

      /* ===================================================== */
      /* ✅ DB 저장 제거 (중요) */
      /* ===================================================== */

      // 상태 저장 (Context + localStorage)
      localStorage.setItem("PLAYER_KEY_CODE", keyCode);
      localStorage.setItem("INTRO_TEAM", handleName);
      localStorage.setItem("INTRO_CODE", handleName2);

      setPlayerKeyCode(keyCode);
      setIntroTeam?.(handleName);
      setIntroInCode?.(handleName2);

      //***** Google Sheet (선택 유지) *****//
      try {
        await saveToSheet({
          introTeam: handleName,
          keyCode: keyCode,
        });
      } catch (sheetError) {
        console.error("시트 저장 실패:", sheetError.message);
      }

      // 다음 페이지 이동
      onFinish?.({ defaultPath });
    } catch (e) {
      console.error(e);
      if (e.message === "유효하지 않은 입장코드입니다.") {
        alert("유효하지 않은 입장코드입니다.");
      } else if (e.message === "입장코드 사용횟수가 초과되었습니다.") {
        alert("사용이 불가한 입장코드입니다.");
      } else {
        alert("저장 실패. 다시 시도해주세요.");
      }
      setIsLoading(false); // 실패 시 로딩 해제
    }
  };

  useEffect(() => {
    pauseTimer();
  }, [pauseTimer]);

  return (
    <div>
      {`${isActive && isActive2 ? "active" : "NONE"}`}
      <div className="intro_pop_box">
        <div className="intro_pop_tc">
          <div className="intro_img"></div>
        </div>
        <FooterButton
          buttonValue={
            isLoading ? (
              <>
                <span className="btn-spinner" />
              </>
            ) : (
              "미션 시작하기"
            )
          }
          handleName={handleName}
          setHandleName={setHandleName}
          handleName2={handleName2}
          setHandleName2={setHandleName2}
          ftIdName="box_ft3"
          btnClass={`inputBtn01 mt16 ${isActive && isActive2 ? "active" : ""}`}
          onFinish={handleStart}
        />
      </div>
    </div>
  );
}

export default Intro;
